class @App.Components.TededCheckmarkList
  checkmarkClasses = [
    'tdd-icon--checkmark',
    'tdd-icon--toggle',
    'tdd-icon--inline'
  ]

  constructor: ->
    @$body = $('body')
    @injectMarkup()

  injectMarkup: ->
    $('[data-checkmark-list]').each (i, el) ->
      $options = $(el).find('input[type="radio"],input[type="checkbox"]')
      $options
        .addClass 'visually-hidden'
        .closest('label')
        .append '<span class="' + checkmarkClasses.join(' ') + '"></span>'

$(document).on 'turbo:load', ->
  if $('[data-checkmark-list]').length > 0
    new App.Components.TededCheckmarkList